import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        "data-slot": "sheet-footer",
        class: _normalizeClass($setup.cn('mt-auto flex flex-col gap-2 p-4', $setup.props.class))
    }, [
        _renderSlot(_ctx.$slots, "default")
    ], 2 /* CLASS */));
}
